import * as requestApprovalStatuses from 'constants/enums/requestApprovalStatuses'

export default {
  [requestApprovalStatuses.NEW]: 'Nová',
  [requestApprovalStatuses.PENDING_SIGNATURE]: 'Na podpis',
  [requestApprovalStatuses.CLOSED]: 'Uzavřená',
  [requestApprovalStatuses.CANCELLED]: 'Zrušena',
}
